import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { PagesComponent } from './pages.component';
import { ProfileComponent } from '../profile/profile.component';
import { AIChat } from './aichat/aichat.component';
import { AIChatMessageComponent } from './aichat/aichatmessage.component';
import { AIChatStatusComponent } from './aichat/aichatstatus.component';
import { AIChatResponseComponent } from './aichat/aichatresponse.component';
import { AIChatAudioComponent } from './aichat/aichataudio.component';
import { AIChatInfoComponent } from './aichat/aichatinfo.component';
import { AIImageComponent } from './aichat/aiimage.component';
import { PartialsModule } from '../partials/partials.module';
import { SharedModule } from '../core/shared/shared.module';
import { IntegrationsComponent } from '../features/integrations/integrations.component';

@NgModule({
  declarations: [
    PagesComponent,
    ProfileComponent,
    AIChat,
    AIChatMessageComponent,
    AIChatResponseComponent,
    AIChatStatusComponent,
    AIChatAudioComponent,
    AIChatInfoComponent,
    AIImageComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    HttpClientModule,
    RouterModule,
    PartialsModule,
    SharedModule,
    IntegrationsComponent
  ],
  exports: [IntegrationsComponent],
  providers: [],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class PagesModule {
  constructor(){
  }
}
